import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Filters from '../../components/TemplateFilters/Filters';
import { useTemplates } from './hooks/useTemplates';
import TemplatesPage from '../../components/TemplateGrid/TemplateLists';
import { getLihpTemplates } from '../../utils/templateGrid/template.util';
import TemplateSearch from '../../components/TemplateSearch/TemplateSearch';
import ivclass from '../IVClass';
import { useRef, useState } from 'react';
import BackToTop from '../../components/TemplateGrid/BackToTop';
import { EVENTS } from '../../constants/events';
import { Analytics } from '../../utils/analytics';
import { AnalyticsType } from '../../types/Analytics';
import { FACET_NAMES } from '../../constants/templateGrid';
const TemplatesGrid = ({ defaultQueryFilters, leftPanelWidth, enableUrlPersist, options = {}, onTemplateSelect, analyticsProps = {}, }) => {
    const { state, onFilterSelected, onFilterCollapsed, onClearAll, fetchMoreTemplates, searchTemplates, autoCompleteSearch, onFavouriteClick, } = useTemplates(defaultQueryFilters, enableUrlPersist);
    const filterProps = {
        filters: state.filters,
        onFilterCollapsed: onFilterCollapsed,
        onFilterSelected: (filter, selected, filterParentKey) => {
            scrollToTop();
            onFilterSelected(filter, selected, filterParentKey);
            const facetKey = filterParentKey;
            Analytics.withEventProperties({
                Source: analyticsProps?.source || 'Quick video',
                'New filter': String(FACET_NAMES[facetKey]),
                'New filter value': filter.name,
            }).send(AnalyticsType.AMPLITUDE, {
                eventName: EVENTS.APPLY_FILTERS,
            });
        },
        onClearAll: onClearAll,
    };
    const [isBackToTopVisible, setIsBackToTopVisible] = useState(false);
    const containerRef = useRef(null);
    const scrollToTop = () => {
        containerRef?.current?.scrollTo({ top: 0, behavior: 'smooth' });
    };
    const handleScroll = () => {
        if (containerRef?.current?.scrollTop &&
            containerRef?.current?.scrollTop > 2000) {
            setIsBackToTopVisible(true);
        }
        else {
            setIsBackToTopVisible(false);
        }
    };
    return (_jsxs("div", { className: ivclass(options.templateGridWrapperClass ||
            'iv-flex iv-h-full iv-overflow-hidden'), children: [options?.showFiltersPanel && (_jsx("div", { style: { width: `${leftPanelWidth}px` }, className: ivclass('iv-border-0 iv-border-r iv-border-solid iv-border-grey-15', 'iv-h-full iv-overflow-auto iv-py-10 iv-pl-[16px] iv-pr-[8px]'), children: _jsx(Filters, { isSearchable: true, ...filterProps }) })), _jsxs("div", { ref: containerRef, onScroll: handleScroll, style: { width: `calc(100% - ${leftPanelWidth}px)` }, className: "iv-h-full iv-overflow-auto iv-relative", children: [options?.showSearch && (_jsxs("div", { className: "iv-sticky iv-top-0 iv-z-[20] iv-bg-grey-0", children: [_jsx("div", { className: "iv-py-10 iv-px-[24px]", children: _jsx(TemplateSearch, { autoComplete: autoCompleteSearch, searchQuery: state.searchQuery, searchTemplates: searchTemplates, scrollToTop: scrollToTop, analyticsSource: analyticsProps?.source }) }), _jsx("hr", { className: "iv-m-[0px] iv-border-grey-15" })] })), _jsx("div", { className: ivclass(options.templateGridContainerClass || 'iv-py-20 iv-px-[24px]'), children: _jsx(TemplatesPage, { searchQuery: state.searchQuery, isFetching: state.loading.templates, showFavourite: options.showFavourite, onFavouriteClick: onFavouriteClick, onTemplateSelect: onTemplateSelect, templates: getLihpTemplates(state.templates.data), fetchMore: fetchMoreTemplates, noMoreTemplates: state.noMoreTemplates, templateGridBreakpoints: options.templateGridBreakpoints }) }), options.enabledBackToTop && isBackToTopVisible && (_jsx(BackToTop, { onClick: scrollToTop }))] })] }));
};
export default TemplatesGrid;
